import { useIsPhone } from "@/lib/hooks/use-is-phone"

/** One sidebar instead of the icon rail plus the inbox panel. Phones keep the bottom bar. */
export function useCombinedNav(): boolean {
	return !useIsPhone()
}
